import React, { useEffect, useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Grid,
  Paper,
  Container,
  Snackbar,
  Alert
} from '@mui/material';
import SubTitle from '../common/SubTitle';
import config from '../../config.json';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { width } from '@fortawesome/free-brands-svg-icons/fa42Group';
import Upload_Icon from "../../images/vehicle/Upload_icon.svg"
import { useTranslation } from 'react-i18next';
export default function OrganizationMain() {
  const navigate = useNavigate();

  const { t } = useTranslation()
  const [orgId, setOrgId] = useState('');
  const [orgData, setOrgData] = useState({});
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true);
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  useEffect(() => {
    const fetchData = async () => {
      const userState = localStorage.getItem('userState');

      if (userState) {
        const parsedUserState = JSON.parse(userState);

        if (parsedUserState?.user?.organizationId) {
          setOrgId(parsedUserState.user.organizationId);

          try {
            setLoading(true);
            const response = await axios.get(`${config.baseURL}/organization/${parsedUserState.user.organizationId}`);
            console.log('Data:', response.data.organization);
            setOrgData(response.data.organization);
            setFormData(response.data.organization);
          } catch (error) {
            console.error('Error fetching organization data:', error);
            setNotification({
              open: true,
              message: 'Failed to load organization data',
              severity: 'error'
            });
          } finally {
            setLoading(false);
          }
        }
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const userState = localStorage.getItem('userState');
      const parsedUserState = JSON.parse(userState);

      const response = await axios.put(
        `${config.baseURL}/organization/${parsedUserState.user.organizationId}`,
        formData
      );

      if (response.data.organization) {
        setOrgData(response.data.organization);
        setNotification({
          open: true,
          message: 'Organization updated successfully',
          severity: 'success'
        });
      }
    } catch (error) {
      console.error('Error updating organization:', error);
      setNotification({
        open: true,
        message: 'Failed to update organization',
        severity: 'error'
      });
    }
  };

  const handleCloseNotification = () => {
    setNotification(prev => ({
      ...prev,
      open: false
    }));
  };

  const handleImageUpload = () => {
    console.log("image upload")
  }
  // Reset form to original data
  const handleCancel = () => {
    setFormData(orgData);
  };
  const handleViewMyFeatures = () => {
    navigate(`/organization/feature/${orgId}`)
  };
  if (loading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>Loading organization data...</Box>;
  }

  return (
    <>
      <SubTitle
        title="Organization Profile"
        path="organization > myOrganization"
        track={"My Features"}
        onTrackClick={handleViewMyFeatures}
      />
      <Box sx={{ margin: "0px 40px" }} >
        {/* Single main box with shadow containing all sections */}
        <Paper sx={{ borderRadius: '8px', overflow: 'hidden', padding: "20px", }}>
          <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
            {/* Organization Details Section */}
            <Box>
              <Box
                sx={{
                  width: '100%',
                  height: 52,
                  gap: 16,
                  pt: 1.5,
                  px: 3,
                  pb: 1.5,
                  borderRadius: "8px",
                  bgcolor: '#647490',
                  boxShadow: '-2px 2px 5px 0px #00000040',
                  color: 'white',
                  fontSize: '1.2rem',
                  fontWeight: 'bold'
                }}
              >
                {t("Organization Details")}
              </Box>

              <Box sx={{ p: 3 }}>
                <Grid container spacing={3}>
                  {/* First row - Organization Name, Website, Country - Equal width */}
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      Organization Name *
                    </Typography>
                    <TextField
                      required
                      fullWidth
                      value={formData.name || ''}
                      onChange={handleInputChange}
                      id="name"
                      placeholder={t("Enter Organization Name")}
                      name="name"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      {t("Website")}
                    </Typography>
                    <TextField
                      fullWidth
                      id="domain"
                      value={formData.domain || ''}
                      onChange={handleInputChange}
                      placeholder="Enter Website"
                      name="domain"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      {t("Country")} *
                    </Typography>
                    <TextField
                      required
                      fullWidth
                      value={formData.country || ''}
                      onChange={handleInputChange}
                      id="country"
                      placeholder={t("Enter Country")}
                      name="country"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  {/* Left side: City, State, Address, Pincode */}
                  <Grid item xs={12} md={8}>
                    <Grid container spacing={3}>
                      {/* Row with City and State */}
                      <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                          {t("City")}
                        </Typography>
                        <TextField
                          fullWidth
                          value={formData.city || ''}
                          onChange={handleInputChange}
                          id="city"
                          placeholder={t("Enter City")}
                          name="city"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                          {t("State")} *
                        </Typography>
                        <TextField
                          required
                          fullWidth
                          value={formData.state || ''}
                          onChange={handleInputChange}
                          id="state"
                          placeholder={t("Enter State")}
                          name="state"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>

                      {/* Row with Address and Pincode */}
                      <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                          {t("Address")} *
                        </Typography>
                        <TextField
                          required
                          fullWidth
                          id="address"
                          value={formData.address || ''}
                          onChange={handleInputChange}
                          placeholder={t("Enter Address")}
                          name="address"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                          {t("Pincode")} *
                        </Typography>
                        <TextField
                          required
                          fullWidth
                          id="pincode"
                          value={formData.pincode || ''}
                          onChange={handleInputChange}
                          placeholder={t("Enter Pincode")}
                          name="pincode"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* Upload area taking up the right side */}
                  <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Box
                      sx={{
                        border: '2px dashed #ccc',
                        borderRadius: '8px',
                        p: 2,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'relative'
                      }}
                    >
                      <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 1
                      }}>
                        <img src={Upload_Icon} alt="Upload" style={{ width: 40, height: 40 }} />
                      </Box>
                      <Box sx={{ textAlign: 'center' }}>
                        <Typography
                          variant="body1"
                          sx={{
                            color: '#1F242E',
                            fontFamily: 'Roboto',
                            fontWeight: 600,
                            fontSize: '16px',
                            lineHeight: '100%',
                            mb: 1
                          }}
                        >
                          {t("Organization Icon")}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          {t("Click to upload or drag and drop")}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#666', fontSize: '12px' }}>
                          {t("PNG, JPG, GIF up to 10MB")}
                        </Typography>
                      </Box>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageUpload}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          opacity: 0,
                          cursor: 'pointer',
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>

            {/* Contact Details Section */}
            <Box>
              <Box
                sx={{
                  width: '100%',
                  height: 52,
                  gap: 16,
                  pt: 1.5,
                  px: 3,
                  pb: 1.5,
                  borderRadius: "8px",
                  bgcolor: '#647490',
                  boxShadow: '-2px 2px 5px 0px #00000040',
                  color: 'white',
                  fontSize: '1.2rem',
                  fontWeight: 'bold'
                }}
              >
                {t("Contact Details")}
              </Box>

              <Box sx={{ p: 3 }}>
                <Grid container spacing={3}>
                  {/* First row - 3 fields */}
                  <Grid item xs={12} sm={4}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      {t("Full Name")} *
                    </Typography>
                    <TextField
                      required
                      fullWidth
                      id="contactName"
                      value={formData.contactName || ''}
                      onChange={handleInputChange}
                      placeholder={t("Enter Full Name")}
                      name="contactName"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      {t("Email")} *
                    </Typography>
                    <TextField
                      required
                      fullWidth
                      id="contactEmail"
                      value={formData.contactEmail || ''}
                      onChange={handleInputChange}
                      placeholder={t("Enter Email")}
                      name="contactEmail"
                      type="email"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      {t("Phone Number")} *
                    </Typography>
                    <TextField
                      required
                      fullWidth
                      id="contactPhone"
                      value={formData.contactPhone || ''}
                      onChange={handleInputChange}
                      placeholder={t("Enter Phone Number")}
                      name="contactPhone"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  {/* Second row - 3 fields */}
                  <Grid item xs={12} sm={4}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      {t("Employee ID")} *
                    </Typography>
                    <TextField
                      required
                      fullWidth
                      id="contactEmployeeId"
                      value={formData.contactEmployeeId || ''}
                      onChange={handleInputChange}
                      placeholder={t("Enter Employee ID")}
                      name="contactEmployeeId"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      {t("Department")} *
                    </Typography>
                    <TextField
                      required
                      fullWidth
                      id="contactDepartment"
                      value={formData.contactDepartment || ''}
                      onChange={handleInputChange}
                      placeholder={("Enter Department")}
                      name="contactDepartment"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      {t("Designation")} *
                    </Typography>
                    <TextField
                      required
                      fullWidth
                      id="contactDesignation"
                      value={formData.contactDesignation || ''}
                      onChange={handleInputChange}
                      placeholder={("Enter Designation")}
                      name="contactDesignation"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Box>

            {/* Transport In-Charge Details Section */}
            <Box>
              <Box
                sx={{
                  width: '100%',
                  height: 52,
                  gap: 16,
                  pt: 1.5,
                  px: 3,
                  pb: 1.5,
                  borderRadius: "8px",
                  bgcolor: '#647490',
                  boxShadow: '-2px 2px 5px 0px #00000040',
                  color: 'white',
                  fontSize: '1.2rem',
                  fontWeight: 'bold'
                }}
              >
                {t("Transport In-Charge Details")} ({t("Optional")})
              </Box>

              <Box sx={{ p: 3 }}>
                <Grid container spacing={3}>
                  {/* First row - 3 fields */}
                  <Grid item xs={12} sm={4}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      {t("Full Name")}
                    </Typography>
                    <TextField
                      fullWidth
                      id="transportFullName"
                      value={formData.transportFullName || ''}
                      onChange={handleInputChange}
                      placeholder={t("Enter Full Name")}
                      name="transportFullName"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      {t("Email")}
                    </Typography>
                    <TextField
                      fullWidth
                      id="transportEmail"
                      value={formData.transportEmail || ''}
                      onChange={handleInputChange}
                      placeholder={t("Enter Email")}
                      name="transportEmail"
                      type="email"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      {t("Phone Number")}
                    </Typography>
                    <TextField
                      fullWidth
                      id="transportPhoneNumber"
                      value={formData.transportPhoneNumber || ''}
                      onChange={handleInputChange}
                      placeholder={t("Enter Phone Number")}
                      name="transportPhoneNumber"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  {/* Second row */}
                  <Grid item xs={12} sm={4}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      {t("Employee ID")}
                    </Typography>
                    <TextField
                      fullWidth
                      id="transportEmployeeId"
                      value={formData.transportEmployeeId || ''}
                      placeholder={t("Enter Employee ID")}
                      name="transportPhoneNumber"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Box>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 2,
                marginTop: 2
              }}
            >
              <Button
                variant="outlined"
                onClick={handleCancel}
                sx={{
                  width: 122,
                  height: 55,
                  borderRadius: '8px',
                  borderWidth: '1px',
                  paddingTop: '16px',
                  paddingRight: '24px',
                  paddingBottom: '16px',
                  paddingLeft: '24px',
                  background: '#F2F2F3',
                  border: '1px solid #414958',
                  color: "#1F242E",
                  fontFamily: "Roboto",
                  fontWeight: "500",
                  fontSize: "20px",
                  textTransform: "none",
                  ":hover": {
                    background: '#F2F2F3',
                  }
                }}
              >
                {t("Cancel")}
              </Button>
              <Button
                variant="contained"
                onClick={handleSubmit}
                sx={{
                  width: 125,
                  height: 55,
                  borderRadius: '8px',
                  borderWidth: '1px',
                  paddingTop: '16px',
                  paddingRight: '24px',
                  paddingBottom: '16px',
                  paddingLeft: '24px',
                  background: '#F9E719',
                  border: '1px solid #414958',
                  color: "#1F242E",
                  fontFamily: "Roboto",
                  fontWeight: "500",
                  fontSize: "20px",
                  textTransform: "none",
                  ":hover": {
                    background: '#F9E719',
                  }
                }}
              >
                {t("Submit")}
              </Button>
            </Box>

          </Box>
        </Paper>
        <Box sx={{ height: 2 }}></Box>
      </Box>

    </>
  )
}